module.exports = __webpack_public_path__ + "static/media/16UNODC34.2ec7d304.jpg";